import { VOTE_COUNT_THRESHOLDS } from '../constants';

const MIN_YEAR = 1874;
const CURRENT_YEAR = new Date().getFullYear();

export function validateDateRange(fromYear, toYear) {
  if (!fromYear && !toYear) {
    return { fromYear, toYear };
  }

  let validFromYear = fromYear;
  let validToYear = toYear;

  if (fromYear) {
    const from = parseInt(fromYear);
    if (from < MIN_YEAR || from > CURRENT_YEAR) {
      validFromYear = '';
    }
  }

  if (toYear) {
    const to = parseInt(toYear);
    if (to < MIN_YEAR || to > CURRENT_YEAR) {
      validToYear = '';
    }

    if (validFromYear && validToYear && parseInt(validToYear) < parseInt(validFromYear)) {
      validToYear = '';
    }
  }

  return { fromYear: validFromYear, toYear: validToYear };
}

export function buildSortParam(sortBy) {
  switch (sortBy) {
    case 'trending':
      return 'trending';
    case 'vote_average':
      return 'vote_average.desc';
    case 'revenue':
      return 'revenue.desc';
    case 'popularity':
      return 'popularity.desc';
    default:
      return 'popularity.desc';
  }
}

export function buildMovieApiParams(filters, searchQuery = null) {
  const params = {};

  params.sort_by = buildSortParam(filters.sortBy);

  if (filters.selectedGenre && filters.selectedGenre !== 'all') {
    params.with_genres = filters.selectedGenre;
  }

  if (filters.imdbRating > 0) {
    params.imdb_rating = filters.imdbRating;
  }

  if (filters.rottenTomatoesRating > 0) {
    params.rt_rating = filters.rottenTomatoesRating;
  }

  const validatedDates = validateDateRange(filters.fromYear, filters.toYear);
  
  if (validatedDates.fromYear) {
    const fromYear = parseInt(validatedDates.fromYear);
    if (fromYear >= MIN_YEAR) {
      params['primary_release_date.gte'] = `${fromYear}-01-01`;
    }
  }
  
  if (validatedDates.toYear) {
    const toYear = parseInt(validatedDates.toYear);
    if (toYear >= MIN_YEAR) {
      params['primary_release_date.lte'] = `${toYear}-12-31`;
    }
  }

  if (filters.availableLT === 'true') {
    params.watch_region = 'LT';
    params.with_watch_monetization_types = 'flatrate|free|ads|rent|buy';
  }

  if (filters.sortBy === 'vote_average' && !searchQuery?.trim()) {
    params['vote_count.gte'] = VOTE_COUNT_THRESHOLDS.MIN_RATING_VOTES;
  }

  if (filters.sortBy === 'revenue') {
    params['revenue.gte'] = VOTE_COUNT_THRESHOLDS.MIN_REVENUE;
  }

  return params;
}

export function buildTVApiParams(filters, searchQuery = null) {
  const params = buildMovieApiParams(filters, searchQuery);
  
  const validatedDates = validateDateRange(filters.fromYear, filters.toYear);
  
  if (validatedDates.fromYear) {
    delete params['primary_release_date.gte'];
    const fromYear = parseInt(validatedDates.fromYear);
    if (fromYear >= MIN_YEAR) {
      params['first_air_date.gte'] = `${fromYear}-01-01`;
    }
  }
  
  if (validatedDates.toYear) {
    delete params['primary_release_date.lte'];
    const toYear = parseInt(validatedDates.toYear);
    if (toYear >= MIN_YEAR) {
      params['first_air_date.lte'] = `${toYear}-12-31`;
    }
  }

  return params;
}

export function buildSearchParams(query, filters = {}) {
  const params = {
    query: query.trim(),
  };

  if (filters.selectedGenre && filters.selectedGenre !== 'all') {
    params.with_genres = filters.selectedGenre;
  }

  if (filters.fromYear) {
    params.year_gte = filters.fromYear;
  }

  if (filters.toYear) {
    params.year_lte = filters.toYear;
  }

  return params;
}

export function buildMediaApiParams(mediaType, filters, searchQuery = null) {
  return mediaType === 'tv' 
    ? buildTVApiParams(filters, searchQuery)
    : buildMovieApiParams(filters, searchQuery);
}
